import React from "react";
import ReactTooltip from "react-tooltip";
import styles from "./style.module.css";

const InputLabel = ({
  id,
  inputWidth,
  width,
  pincodeType,
  value,
  borderRadius,
  onChange,
  placeholder,
  paddingBottom,
  nameError,
  placeholderSize,
  paddingLeft,
  paddingTop,
  keyColor,
  keyLabel,
  disabled,
  entermethod,
  height,
  type,
  iconid,
  keyweight,
  autoComplete
}) => {
  const getMaxLength = () => {
    if (type === "number" && pincodeType === true) {
      return "6";
    } else if (type === "number") {
      return "10";
    } else if (type === "gst") {
      return "15";
    } else if (type === "pan") {
      return "10";
    }
  };

  return (
    <div className={styles.labelInput} style={{ position: "relative" }}>
      <div
        className={styles.labelFormat}
        style={{ color: keyColor, fontWeight: keyweight }}>
        {keyLabel}
      </div>
      <div
        className={styles.InputFormat}
        style={{
          flexDirection: "column",
          // width: nameError === null || nameError === undefined ? "" : "98%",
        }}>
        <input
          style={{
            paddingLeft: paddingLeft,
            textAlign:"",
            border:
              nameError === null || nameError === undefined
                ? "1px solid #c3ccc3"
                : "1px solid red",
            paddingTop: paddingTop,
            width:`${width}vh`,
            paddingBottom: paddingBottom,
            verticalAlign:"top",
            borderRadius: `${borderRadius}px`,
            height: `${height}vh`,
            fontSize: placeholderSize,

            // resize: "none",
            color: "#171717",
          }}
          autoComplete={autoComplete ?? "not-on"}
          // nameError={nameError}
          disabled={disabled}
          iconid={iconid}
          placeholder={placeholder}
          
          // typeForm="ship"
          maxLength={getMaxLength()}
          onKeyPress={(event) => {
            if (type === "number") {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            } else if (type === "pressEnter") {
              if (event.key === "Enter") {
                if (entermethod) {
                  entermethod();
                }
              }
            }
          }}
          // min="0"
          id={id}
          // type = {type === "password" ? "password" :  "text"}
          // pattern="[0-9]*"
          className={styles.inputboxFormat}
          // type="number"
          // style={{ marginBottom: 0 }}
          value={value}
          // shipname={shipname}
          onChange={onChange}
          // errorstylePosition={errorstylePosition}
          // required
        />
        <div
          style={{
            color: "red",
            fontSize: 10,
            fontStyle: "italic",
            fontWeight: 300,
            marginLeft: "1rem",
          }}>
          {nameError}
        </div>
        {nameError !== null ? (
          <ReactTooltip
            place="top"
            placement="top"
            type="dark"
            id={iconid}
            effect="solid">
            <span>{nameError}</span>
          </ReactTooltip>
        ) : (
          <span></span>
        )}
      </div>
    </div>
  );
};

export default InputLabel;
